/*
 * Amber Harlow · Island Planner V2 (sections/hl-planner.liquid)
 * Rules and maths: window.HLPlan (snippets/hl-planner-core.liquid). PDF: assets/hl-planner-pdf.js, loaded on click.
 * All lengths are inches internally; centimeters are only a display unit.
 */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';

  // Kitchen photo geometry (viewBox 1000 x 860, visible band y 120–800). The island top is at y 700 and the photo is
  // treated at one fixed scale: 920 units = a 108″ (9 ft) run of island, so every pendant, spacing and drop keeps the
  // same proportions whatever the island length. Longer islands pull the camera back (the photo is scaled down).
  var SC = { X0: 40, X1: 960, CX: 500, COUNTER: 700, VTOP: 120, VBOT: 800, REF: 108 };
  SC.UPI = (SC.X1 - SC.X0) / SC.REF;

  function el(tag, attrs, parent, text) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    if (text != null) e.textContent = text;
    if (parent) parent.appendChild(e);
    return e;
  }
  function money(cents, cur) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  function Planner(root) {
    var P = window.HLPlan, R = P.rules;
    var dataEl = root.querySelector('[data-planner-data]');
    var D = null; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var isProduct = root.dataset.mode === 'product';
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return root.querySelectorAll(s); };
    var params = new URLSearchParams(location.search), kept = P.saved() || {};
    var state = {
      L: clamp(parseFloat(params.get('ip_len')) || kept.L || 96, 36, 240),
      unit: kept.unit === 'cm' ? 'cm' : 'in', ceil: parseFloat(params.get('ip_ceil')) || kept.ceil || null, counter: R.counter,
      n: parseInt(params.get('ip_n'), 10) || null, userShade: 14, view: 'scene', cart: { qty: 0, lines: [] }, busy: false
    };
    var cur = null; // current computed plan snapshot

    /* ---------- variant & product data ---------- */
    function buyForm() {
      var main = root.ownerDocument.querySelector('[id$="__main"] form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      return main;
    }
    function variant() {
      var f = isProduct && buyForm(), id = f && f.querySelector('[name="id"]') && f.querySelector('[name="id"]').value;
      for (var i = 0; i < D.variants.length; i++) if (String(D.variants[i].id) === String(id)) return D.variants[i];
      var pid = params.get('variant');
      for (var j = 0; j < D.variants.length; j++) if (String(D.variants[j].id) === pid) return D.variants[j];
      return D.variants[0];
    }
    function silFor(v) { return (v.sil !== 'p' && D.sils[v.sil]) || D.productSil || null; }

    /* ---------- maths ---------- */
    function compute() {
      var v = variant(), linearMode = v.m === 'linear' && !!v.l;
      var known = v.s != null && v.s > 0;
      var s = known ? v.s / 2.54 : (v.m === 'linear' ? null : state.userShade);
      var H = v.h != null ? v.h / 2.54 : null, L = state.L, c;
      if (linearMode) {
        var lin = P.linear(L, v.l / 2.54);
        c = { mode: 'linear', L: L, s: v.l / 2.54, len: v.l / 2.54, H: H, n: 1, rec: lin.ok ? 1 : 0, chosen: lin, all: [lin], known: true };
      } else if (v.m === 'linear') {
        // A bar fixture whose length is not published: no spacing can be computed honestly
        c = { mode: 'linear-unknown', L: L, s: null, H: H, n: 1, rec: 0, chosen: null, all: [], known: false };
      } else {
        var pl = P.plan(L, s), n = state.n && pl.all[state.n - 1] && pl.all[state.n - 1].ok ? state.n : pl.rec;
        c = { mode: 'multi', L: L, s: s, H: H, rec: pl.rec, n: n, chosen: n ? pl.all[n - 1] : null, all: pl.all, known: known, target: pl.target };
      }
      c.v = v; c.ceil = state.ceil; c.counter = state.counter;
      c.drop = P.drop(state.ceil, state.counter, H);
      c.cord = D.product.cord != null ? D.product.cord / 2.54 : null;
      c.sil = silFor(v); c.silIsVariant = (v.sil !== 'p' && !!D.sils[v.sil]) || !!v.feat;
      return c;
    }

    /* ---------- formatting ---------- */
    function len(x) { return state.unit === 'cm' ? P.cm(x) : P.frac(x); }
    function both(x) { return P.frac(x) + ' · ' + P.cm(x); }
    function setText(sel, t) { var e = q(sel); if (e) e.textContent = t; }

    /* ---------- controls ---------- */
    var num = q('[data-len-num]'), range = q('[data-length]'), ceilNum = q('[data-ceil-num]'), counterNum = q('[data-counter]');
    function showLength() {
      var L = state.L;
      if (document.activeElement !== num) num.value = state.unit === 'cm' ? (Math.round(L * 2.54 * 10) / 10) : (Math.round(L * 4) / 4);
      num.min = state.unit === 'cm' ? 91 : 36; num.max = state.unit === 'cm' ? 610 : 240; num.step = state.unit === 'cm' ? 0.5 : 0.25;
      setText('[data-len-unit]', state.unit);
      setText('[data-len-conv]', state.unit === 'cm' ? P.frac(L) + ' · ' + P.ft(L) : P.ft(L) + ' · ' + P.cm(L));
      num.style.setProperty('--len-ch', Math.max(2, String(num.value).length));
      range.value = Math.round(L);
      range.setAttribute('aria-valuetext', Math.round(L) + ' inches, ' + P.cm(L));
      range.style.setProperty('--hl-fill', ((L - 36) / (240 - 36) * 100) + '%');
      qa('[data-preset]').forEach(function (b) { b.setAttribute('aria-pressed', String(Math.abs(Number(b.dataset.preset) - L) < 0.01)); });
      qa('[data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.unit === state.unit)); });
      var C = state.ceil;
      if (document.activeElement !== ceilNum) ceilNum.value = C ? (state.unit === 'cm' ? Math.round(C * 2.54) : Math.round(C)) : '';
      ceilNum.placeholder = state.unit === 'cm' ? 'e.g. 274' : 'e.g. 108';
      setText('[data-ceil-unit]', state.unit); setText('[data-counter-unit]', state.unit);
      if (document.activeElement !== counterNum) counterNum.value = state.unit === 'cm' ? Math.round(state.counter * 2.54) : Math.round(state.counter);
      setText('[data-ceil-conv]', C ? (state.unit === 'cm' ? P.ft(C) : P.ft(C) + ' · ' + P.cm(C, 0)) : '');
      setText('[data-ceil-sum]', C ? P.ft(C) + ' ceiling' : 'Checks the cord length');
      qa('[data-ceil]').forEach(function (b) { b.setAttribute('aria-pressed', String(C === Number(b.dataset.ceil))); });
    }
    function showShade(c) {
      var fixed = q('[data-shade-fixed]'), edit = q('[data-shade-edit]'), hint = q('[data-shade-hint]');
      if (c.mode === 'linear') {
        setText('[data-shade-label]', 'Fixture length');
        q('[data-shade-out]').innerHTML = P.frac(c.len) + ' <small>' + P.cm(c.len) + '</small>';
        setText('[data-shade-src]', 'One bar fixture, from the selected option');
        fixed.hidden = false; edit.hidden = true; hint.hidden = true;
      } else if (c.mode === 'linear-unknown') {
        setText('[data-shade-label]', 'Fixture length');
        q('[data-shade-out]').textContent = 'Not published';
        setText('[data-shade-src]', 'Ask us for this option\'s length');
        fixed.hidden = false; edit.hidden = true; hint.hidden = true;
      } else if (c.known) {
        setText('[data-shade-label]', 'Shade diameter');
        q('[data-shade-out]').innerHTML = P.frac(c.s) + ' <small>' + P.cm(c.s) + (c.H ? ' · ' + P.frac(c.H) + ' tall' : '') + '</small>';
        setText('[data-shade-src]', D.variants.length > 1 ? 'From the selected option' : 'Published size');
        fixed.hidden = false; edit.hidden = true; hint.hidden = true;
      } else {
        setText('[data-shade-label]', 'Your shade diameter');
        q('[data-shade-edit-out]').innerHTML = P.frac(c.s) + ' <small>' + P.cm(c.s) + '</small>';
        fixed.hidden = true; edit.hidden = false; hint.hidden = false;
      }
    }
    function fitLabel(o) { return o.fit === 'good' ? 'balanced' : o.fit === 'tight' ? 'closer' : o.fit === 'wide' ? 'wider' : 'not advised'; }
    function showConfigs(c) {
      var box = q('[data-configs]'), field = q('[data-configs-field]');
      box.innerHTML = '';
      if (c.mode !== 'multi') { field.hidden = true; return; }
      field.hidden = false;
      var lo = Math.max(1, (c.rec || 1) - 2), hi = Math.min(R.maxCount, Math.max(c.rec, 1) + 2);
      for (var n = lo; n <= hi; n++) {
        var o = c.all[n - 1], b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'radio'); b.dataset.n = n;
        b.setAttribute('aria-checked', String(n === c.n));
        b.disabled = !o.ok;
        if (n === c.rec) b.classList.add('is-rec');
        b.innerHTML = (n === c.rec ? '<em>Recommended</em>' : '') + '<strong>' + n + '</strong><small>' + (o.ok ? fitLabel(o) : 'won\'t fit') + '</small>';
        b.setAttribute('aria-label', n + (n === 1 ? ' pendant' : ' pendants') + (n === c.rec ? ', recommended' : '') + (o.ok ? (o.gap ? ', ' + Math.round(o.gap * 10) / 10 + ' inches apart' : '') : ', ' + o.why));
        if (!o.ok) b.title = o.why;
        box.appendChild(b);
      }
      setText('[data-configs-note]', c.rec ? 'Compare layouts' : '');
    }
    function showMessage(c) {
      var m = q('[data-msg]'), t = '', warn = false, ch = c.chosen;
      if (c.mode === 'linear-unknown') { t = 'This option is a bar fixture whose length isn\'t published, so we can\'t check it against your island. Ask us before ordering and we\'ll confirm it.'; warn = true; }
      else if (c.mode === 'linear') {
        if (!ch.ok) { t = ch.why + ' for a ' + P.frac(c.L) + ' island: designers keep at least ' + R.linearEndClear + '″ of counter visible at each end.'; warn = true; }
        else if (ch.fit === 'tight') t = 'Only ' + P.frac(ch.clear) + ' at each end: the bar will read almost full length. Designers usually choose a bar of about ½ to ⅔ of the island.';
        else if (ch.fit === 'wide') t = 'This bar covers less than half of a ' + P.frac(c.L) + ' island and may look undersized. Designers usually choose about ½ to ⅔ of the island length.';
      }
      else if (!c.rec) { t = 'A ' + P.frac(c.s) + ' shade is too wide for a ' + P.frac(c.L) + ' island: keep at least ' + R.minEndClear + '″ clear at each end.'; warn = true; }
      else if (ch && c.n !== c.rec && ch.fit === 'tight') t = 'Closer than the usual ' + c.target + '″ rhythm for this shade size. It works for a fuller look; the recommended layout is ' + c.rec + '.';
      else if (ch && c.n !== c.rec && ch.fit === 'wide') t = 'More open than the usual ' + c.target + '″ rhythm for this shade size; the recommended layout is ' + c.rec + '.';
      if (c.mode === 'multi' && !c.known && c.rec) t = 'Based on your estimate: this model\'s shade diameter isn\'t published, so check it with us before ordering.' + (t ? ' ' + t : '');
      if (c.drop && c.chosen) {
        var need = c.drop, cord = c.cord, dt = '';
        if (need.max <= 0) { dt = 'With this ceiling there is no room to hang the shade 30–36″ above the counter.'; warn = true; }
        else if (cord == null) dt = 'Estimated suspension: about ' + P.frac(Math.max(0, need.min)) + '–' + P.frac(need.max) + (need.knowsHeight ? '' : ' plus the fixture height') + ' from the ceiling. The cord length of this model isn\'t published: ask us to confirm it reaches.';
        else if (cord >= need.max) dt = 'Estimated suspension: about ' + P.frac(Math.max(0, need.min)) + '–' + P.frac(need.max) + (need.knowsHeight ? '' : ' plus the fixture height') + '. The listed cord is ' + P.frac(cord) + ' (' + P.cm(cord, 0) + '). Your electrician sets the final height on site.';
        else if (cord >= need.min) dt = 'The listed cord (' + P.frac(cord) + ') reaches the upper part of the range only: the shade would sit about ' + P.frac(c.ceil - c.counter - (c.H || 0) - cord) + ' above the counter.';
        else { dt = 'The listed cord (' + P.frac(cord) + ') is shorter than the ' + P.frac(need.min) + ' this ceiling needs. Ask us about an extension before ordering.'; warn = true; }
        t = t ? t + ' ' + dt : dt;
      }
      m.textContent = t; m.hidden = !t; m.classList.toggle('is-warn', warn);
    }
    function showStats(c) {
      var ch = c.chosen;
      if (c.mode === 'multi') {
        setText('[data-lab-n]', 'Pendants'); setText('[data-out-n]', ch ? c.n : '—');
        setText('[data-out-n-s]', !ch ? 'won\'t fit' : (c.n === c.rec ? 'recommended' : 'your choice'));
        setText('[data-lab-gap]', 'Center to center'); setText('[data-lab-edge]', 'End to first center');
        setText('[data-out-gap]', ch && ch.gap ? len(ch.gap) : '—');
        setText('[data-out-gap-m]', ch && ch.gap ? (state.unit === 'cm' ? P.frac(ch.gap) : P.cm(ch.gap)) : (ch ? 'single pendant' : ''));
        setText('[data-out-edge]', ch ? len(ch.edge) : '—');
        setText('[data-out-edge-m]', ch ? (state.unit === 'cm' ? P.frac(ch.edge) : P.cm(ch.edge)) : '');
      } else {
        setText('[data-lab-n]', 'Fixtures'); setText('[data-out-n]', '1'); setText('[data-out-n-s]', 'one bar, centered');
        setText('[data-lab-gap]', 'Fixture length'); setText('[data-lab-edge]', 'Clear at each end');
        setText('[data-out-gap]', c.len ? len(c.len) : '—'); setText('[data-out-gap-m]', c.len ? (state.unit === 'cm' ? P.frac(c.len) : P.cm(c.len)) : 'not published');
        setText('[data-out-edge]', c.chosen ? len(Math.max(0, c.chosen.clear)) : '—'); setText('[data-out-edge-m]', c.chosen ? 'designers keep ' + R.linearEndClear + '″+' : '');
      }
    }

    /* ---------- price & cart ---------- */
    function tiers() {
      var b = document.querySelector('.hl-bundle[data-t2]');
      return { t2: b ? Number(b.dataset.t2) : D.bundle.t2, t3: b ? Number(b.dataset.t3) : D.bundle.t3 };
    }
    function existing(v) { var n = 0; state.cart.lines.forEach(function (l) { if (String(l.variant_id) === String(v.id)) n += l.quantity; }); return n; }
    function priceFor(c, mode) {
      // Shopify's automatic bundle discounts count every piece in the cart and round the discount down to the cent
      var v = c.v, n = c.n || 0, ex = existing(v), others = mode === 'alone' ? 0 : state.cart.qty - ex;
      var after = mode === 'set' ? others + n : (mode === 'alone' ? n : state.cart.qty + n), t = tiers();
      var pct = after >= 3 ? t.t3 : (after === 2 ? t.t2 : 0);
      var full = v.price * n, disc = Math.floor(full * pct / 100), was = v.compare > v.price ? v.compare * n : 0;
      return { n: n, full: full, now: full - disc, pct: pct, disc: disc, was: was, save: (was ? was - full : 0) + disc, mixed: others > 0 };
    }
    function showPrice(c) {
      var box = q('[data-price]'); if (!box) return;
      var add = q('[data-add]'), lab = q('[data-add-label]'), alt = q('[data-set]'), inc = q('[data-incart]');
      var v = c.v, ok = !!(c.chosen && c.chosen.ok) && c.mode !== 'linear-unknown', n = c.n || 0, ex = existing(v);
      if (!ok || !n) {
        box.innerHTML = ''; inc.hidden = true; alt.hidden = true;
        add.disabled = true; lab.textContent = c.mode === 'linear-unknown' ? 'Ask us about this option' : 'This layout won\'t fit';
        return;
      }
      if (!v.avail) { box.innerHTML = ''; add.disabled = true; lab.textContent = 'Sold out'; alt.hidden = true; inc.hidden = true; return; }
      var pr = priceFor(c, 'add'), cur = D.currency, opt = D.variants.length > 1 && v.t ? v.t : '';
      // One price line: total, struck reference, then quantity, option and saving (the button no longer repeats the amount)
      box.innerHTML = '<span class="hl-pp__now">' + money(pr.now, cur) + '</span>' + (pr.disc || pr.was ? '<s class="hl-pp__was">' + money(pr.was || pr.full, cur) + '</s>' : '<span></span>') +
        '<span class="hl-pp__meta">' + (pr.pct ? '<span class="hl-pp__tag">Bundle −' + pr.pct + '%</span>' : '') + '<span>' + n + ' × ' + money(v.price, cur) + (opt ? ' · ' + esc(opt) : '') + '</span>' +
        (pr.save ? '<span class="hl-pp__save">You save ' + money(pr.save, cur) + '</span>' : '') + '</span>' +
        (pr.pct && pr.mixed ? '<span class="hl-pp__mix">The bundle counts every piece in your cart.</span>' : '');
      add.disabled = state.busy;
      lab.textContent = state.busy ? 'Adding…' : (ex ? 'Add ' + n + ' more to cart' : 'Add ' + n + ' to cart');
      if (ex) {
        inc.hidden = false;
        inc.textContent = 'You already have ' + ex + ' of this option in your cart.';
        alt.hidden = ex === n; alt.textContent = 'Make it ' + n + ' in total instead';
      } else { inc.hidden = true; alt.hidden = true; }
    }
    function refreshCart() {
      return fetch((window.Theme && Theme.routes && Theme.routes.cart_url ? Theme.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { state.cart = { qty: cart.item_count, lines: cart.items }; render(); })
        .catch(function () {});
    }
    function setQtyInForm(n) {
      // Keep the buy box and the "Choose your set" block on the same quantity as the planner
      var opt = document.querySelector('.hl-bundle [data-qty="' + n + '"]');
      if (opt) { opt.click(); return; }
      var f = buyForm(), qi = f && (f.querySelector('[name="quantity"]') || (f.closest('.shopify-section') || document).querySelector('[name="quantity"]'));
      if (qi) { qi.value = n; qi.dispatchEvent(new Event('input', { bubbles: true })); qi.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    function cartMutate(mode) {
      var c = cur; if (!c || !c.chosen || !c.n || state.busy) return;
      var v = c.v, n = c.n, line = null;
      state.cart.lines.forEach(function (l) { if (!line && String(l.variant_id) === String(v.id)) line = l; });
      var lines = mode === 'set' && line ? [{ id: line.key, quantity: n }] : [{ merchandiseId: String(v.id), quantity: n }];
      var A = window.Shopify && Shopify.actions;
      state.busy = true; render();
      var done = function () { state.busy = false; refreshCart(); };
      if (!A || !A.updateCart) {
        // Fallback: the theme's own buy form (opens the drawer the same way as Add to cart)
        setQtyInForm(n);
        var btn = buyForm() && buyForm().querySelector('[name="add"], button[type="submit"]');
        if (btn) btn.click();
        setTimeout(done, 1200); return;
      }
      A.updateCart({ lines: lines }, { event: { context: 'product' } }).then(function (res) {
        var err = res && res.userErrors && res.userErrors[0];
        if (err) throw new Error(err.message);
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) { try { Shopify.analytics.publish('hl_planner_add', { variant_id: v.id, quantity: n, island_in: c.L, mode: mode }); } catch (e) {} }
        return A.openCart();
      }).then(done).catch(function (e) {
        state.busy = false; render();
        var m = q('[data-msg]'); m.hidden = false; m.classList.add('is-warn');
        m.textContent = (e && e.message ? e.message : 'We couldn\'t update your cart.') + ' Please try again.';
      });
    }

    /* ---------- kitchen view ---------- */
    var svg = q('[data-svg]'), photo = q('[data-photo]'), blur = q('[data-blur]'), sceneBox = q('[data-scene]');
    var uid = 'hlp' + Math.random().toString(36).slice(2, 7);
    function drawScene(c, o) {
      var forPdf = !!(o && o.pdf);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var L = c.L, z = Math.min(1, SC.REF / L), u = SC.UPI * z;
      photo.style.transform = z < 1 ? 'scale(' + z + ')' : '';
      sceneBox.classList.toggle('is-wide', z < 1);
      var defs = el('defs', {}, svg);
      var cone = el('linearGradient', { id: uid + 'c', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      el('stop', { offset: 0, 'stop-color': '#FFE2B8', 'stop-opacity': '.32' }, cone); el('stop', { offset: 1, 'stop-color': '#FFE2B8', 'stop-opacity': 0 }, cone);
      var pool = el('radialGradient', { id: uid + 'p' }, defs);
      el('stop', { offset: 0, 'stop-color': '#FFE6C2', 'stop-opacity': '.85' }, pool); el('stop', { offset: 1, 'stop-color': '#FFE2B8', 'stop-opacity': 0 }, pool);
      var halo = el('radialGradient', { id: uid + 'h' }, defs);
      el('stop', { offset: 0, 'stop-color': '#FFE3BC', 'stop-opacity': '.34' }, halo); el('stop', { offset: .55, 'stop-color': '#FFD9A8', 'stop-opacity': '.1' }, halo); el('stop', { offset: 1, 'stop-color': '#FFD9A8', 'stop-opacity': 0 }, halo);
      var soft = el('filter', { id: uid + 's', x: '-30%', y: '-10%', width: '160%', height: '120%' }, defs); el('feGaussianBlur', { stdDeviation: 14 }, soft);
      var drop = el('filter', { id: uid + 'd', x: '-20%', y: '-20%', width: '140%', height: '160%' }, defs);
      el('feDropShadow', { dx: 0, dy: 6, stdDeviation: 8, 'flood-color': '#000', 'flood-opacity': '.3' }, drop);
      var shadeL = el('linearGradient', { id: uid + 'eL', x1: 0, y1: 0, x2: 1, y2: 0 }, defs);
      el('stop', { offset: 0, 'stop-color': '#160F0C', 'stop-opacity': '.5' }, shadeL); el('stop', { offset: 1, 'stop-color': '#160F0C', 'stop-opacity': '.28' }, shadeL);
      var shadeR = el('linearGradient', { id: uid + 'eR', x1: 1, y1: 0, x2: 0, y2: 0 }, defs);
      el('stop', { offset: 0, 'stop-color': '#160F0C', 'stop-opacity': '.5' }, shadeR); el('stop', { offset: 1, 'stop-color': '#160F0C', 'stop-opacity': '.28' }, shadeR);

      var xl = SC.CX - L * u / 2, xr = SC.CX + L * u / 2, top0 = SC.VTOP;
      // A shorter island than the photo's: the counter beyond its ends is veiled
      if (xl > SC.X0 + 1) {
        el('rect', { x: 0, y: SC.COUNTER - 30, width: xl, height: SC.VBOT - SC.COUNTER + 30, fill: 'url(#' + uid + 'eL)' }, svg);
        el('rect', { x: xr, y: SC.COUNTER - 30, width: 1000 - xr, height: SC.VBOT - SC.COUNTER + 30, fill: 'url(#' + uid + 'eR)' }, svg);
        [xl, xr].forEach(function (x) { el('line', { x1: x, y1: SC.COUNTER - 22, x2: x, y2: SC.VBOT - 20, stroke: 'rgba(255,255,255,.55)', 'stroke-width': 1.2, 'stroke-dasharray': '3 4' }, svg); });
      }
      var sil = c.sil, light = el('g', { style: 'mix-blend-mode:screen' }, svg), fx = el('g', {}, svg);
      var items = [];
      if (c.mode === 'multi' && c.chosen) c.chosen.pos.forEach(function (p) { items.push({ x: xl + p * u, w: c.s * u }); });
      else if (c.mode === 'linear' && c.chosen) items.push({ x: SC.CX, w: c.len * u });
      else if (c.mode === 'multi' && !c.chosen && c.s) items.push({ x: SC.CX, w: c.s * u, ghost: true });
      var bottom = SC.COUNTER - P.hangFor(c.ceil) * u;
      var ceilY = c.ceil ? SC.COUNTER - (c.ceil - c.counter) * u : null;
      items.forEach(function (it) {
        var w = it.w, k = sil ? w / sil.w : 0, sh = sil ? (sil.h - sil.st) * k : (c.H ? c.H * u : w * 0.55), cx = it.x, top = bottom - sh;
        var g = it.ghost ? el('g', { opacity: '.45' }, fx) : fx;
        if (!it.ghost) {
          el('polygon', { points: (cx - w * .32) + ',' + bottom + ' ' + (cx + w * .32) + ',' + bottom + ' ' + (cx + w * .9) + ',' + SC.COUNTER + ' ' + (cx - w * .9) + ',' + SC.COUNTER, fill: 'url(#' + uid + 'c)', filter: 'url(#' + uid + 's)' }, light);
          el('ellipse', { cx: cx, cy: SC.COUNTER + 14, rx: w * 1.1, ry: 26 * Math.max(.6, z), fill: 'url(#' + uid + 'p)' }, light);
          // A soft warm halo behind the shade separates it from the dark wall (screen only; the shade itself is untouched)
          if (!forPdf) el('ellipse', { cx: cx, cy: bottom - sh * .45, rx: Math.max(w, sh) * .95, ry: Math.max(w, sh) * .85, fill: 'url(#' + uid + 'h)' }, light);
        }
        var cordTop = ceilY && ceilY > top0 + 4 && ceilY < top - 20 ? ceilY : top0 - 2;
        if (cordTop > top0) el('rect', { x: cx - 16 * z, y: cordTop - 6 * z, width: 32 * z, height: 7 * z, rx: 3, fill: '#1E1C1B' }, g);
        el('line', { x1: cx, y1: cordTop, x2: cx, y2: top + 3, stroke: '#1E1C1B', 'stroke-width': 2.2 * Math.max(.7, z) }, g);
        if (sil) {
          var gg = el('g', { transform: 'translate(' + (cx - sil.w * k / 2) + ' ' + (bottom - sil.h * k) + ') scale(' + k + ')', filter: 'url(#' + uid + 'd)' }, g);
          var clip = el('clipPath', { id: uid + 'k' + Math.round(cx) }, defs); el('rect', { x: -10, y: sil.st, width: sil.w + 20, height: sil.h - sil.st + 10 }, clip);
          var cut = el('clipPath', { id: uid + 'q' + Math.round(cx) }, defs); el('path', { d: sil.d, 'clip-rule': 'evenodd' }, cut);
          var gc = el('g', { 'clip-path': 'url(#' + uid + 'k' + Math.round(cx) + ')' }, gg);
          el('image', { href: sil.u, x: sil.ix, y: sil.iy, width: sil.iw, height: sil.ih, preserveAspectRatio: 'none', 'clip-path': 'url(#' + uid + 'q' + Math.round(cx) + ')' }, gc);
        } else {
          el('path', { d: 'M' + (cx - w / 2) + ' ' + bottom + ' Q' + cx + ' ' + (bottom - sh * 1.9) + ' ' + (cx + w / 2) + ' ' + bottom + ' Z', fill: '#2B2826', filter: 'url(#' + uid + 'd)' }, g);
        }
        if (!it.ghost) el('ellipse', { cx: cx, cy: bottom + 1, rx: w * .22, ry: 4, fill: '#FFE9C9', opacity: .9 }, fx);
      });
      // Measurements, drawn like an architect's overlay (sized for the screen, not the photo)
      var px = 1000 / Math.max(300, svg.getBoundingClientRect().width || 700), fs = clamp(12.5 * px, 15, 40);
      var dim = el('g', { stroke: 'rgba(255,255,255,.8)', 'stroke-width': 1.3 * Math.max(1, px / 1.4), fill: 'none' }, svg), ty = SC.VBOT - 10;
      if (!forPdf) { sceneDims(c, items, xl, xr, bottom, px); finishScene(c); return; }
      el('line', { x1: xl, y1: ty - 10, x2: xr, y2: ty - 10 }, dim);
      el('line', { x1: xl, y1: ty - 18, x2: xl, y2: ty - 2 }, dim); el('line', { x1: xr, y1: ty - 18, x2: xr, y2: ty - 2 }, dim);
      label(SC.CX, ty - 10 - fs * .55, P.frac(L) + ' island · ' + P.cm(L), fs);
      if (c.mode === 'multi' && c.chosen && c.n > 1) {
        var x0 = items[0].x, x1 = items[1].x, gy = bottom + Math.max(30, fs * 1.4);
        el('line', { x1: x0, y1: gy, x2: x1, y2: gy, 'stroke-dasharray': '4 4' }, dim);
        el('line', { x1: x0, y1: gy - 7, x2: x0, y2: gy + 7 }, dim); el('line', { x1: x1, y1: gy - 7, x2: x1, y2: gy + 7 }, dim);
        label((x0 + x1) / 2, gy - 9, P.frac(c.chosen.gap) + ' · ' + P.cm(c.chosen.gap), fs);
      }
      finishScene(c);
    }
    function finishScene(c) {
      var cap = q('[data-cap]');
      if (!c.silIsVariant && D.variants.length > 1 && c.sil && state.view === 'scene') { cap.hidden = false; cap.textContent = 'Illustration shows the main photo\'s finish'; }
      else cap.hidden = true;
    }
    // On screen: thin white dimension lines with the values on small glass labels, readable over the bright counter
    function sceneDims(c, items, xl, xr, bottom, px) {
      var fs = clamp(11.5 * px, 14, 34), sw = Math.max(1, px / 1.3), y = SC.VBOT - 26;
      var g = el('g', { stroke: 'rgba(255,255,255,.9)', 'stroke-width': sw, fill: 'none', 'stroke-linecap': 'round' }, svg);
      el('line', { x1: xl, y1: y, x2: xr, y2: y }, g);
      [xl, xr].forEach(function (x) { el('line', { x1: x, y1: y - 9 * sw, x2: x, y2: y + 9 * sw }, g); });
      chip(SC.CX, y, P.frac(c.L) + ' island · ' + P.cm(c.L), fs);
      if (c.mode === 'multi' && c.chosen && c.n > 1) {
        var x0 = items[0].x, x1 = items[1].x, gy = bottom + Math.max(34, fs * 1.8);
        el('line', { x1: x0, y1: gy, x2: x1, y2: gy, 'stroke-dasharray': (3 * sw) + ' ' + (4 * sw) }, g);
        [x0, x1].forEach(function (x) { el('line', { x1: x, y1: gy - 7 * sw, x2: x, y2: gy + 7 * sw }, g); });
        if (x1 - x0 > fs * 6) chip((x0 + x1) / 2, gy, P.frac(c.chosen.gap) + ' apart', fs);
      } else if (c.mode === 'linear' && c.chosen && items[0]) {
        var it = items[0], ly = bottom + Math.max(34, fs * 1.8);
        el('line', { x1: it.x - it.w / 2, y1: ly, x2: it.x + it.w / 2, y2: ly }, g);
        chip(it.x, ly, P.frac(c.len) + ' fixture', fs);
      }
    }
    function chip(x, y, text, fs) {
      var g = el('g', { style: 'font-family:var(--hl-sans),sans-serif' }, svg);
      var r = el('rect', { fill: 'rgba(24,15,12,.62)', stroke: 'rgba(255,255,255,.28)', 'stroke-width': 1 }, g);
      var t = el('text', { x: x, y: y + fs * .36, 'text-anchor': 'middle', fill: '#fff', 'font-size': fs, 'font-weight': 600, 'letter-spacing': '.04em', style: 'font-family:var(--hl-sans),sans-serif' }, g, text);
      var w = 0; try { w = t.getComputedTextLength(); } catch (e) {}
      if (!w) w = text.length * fs * .56;
      var h = fs * 1.9, pw = w + fs * 1.5;
      r.setAttribute('x', x - pw / 2); r.setAttribute('y', y - h / 2); r.setAttribute('width', pw); r.setAttribute('height', h); r.setAttribute('rx', h / 2);
    }
    function label(x, y, text, fs) {
      el('text', { x: x, y: y, 'text-anchor': 'middle', fill: '#fff', 'font-size': fs, 'font-family': 'var(--hl-sans), sans-serif', 'letter-spacing': '.03em', style: 'paint-order:stroke;stroke:rgba(0,0,0,.5);stroke-width:4px;font-family:var(--hl-sans),sans-serif' }, svg, text);
    }

    /* ---------- technical layout ---------- */
    var tsvg = q('[data-tech-svg]');
    function drawTech(target, c, opts) {
      opts = opts || {};
      var S = target; while (S.firstChild) S.removeChild(S.firstChild);
      var W = 1000, Ht = 680, px = opts.px || (1000 / Math.max(300, S.getBoundingClientRect().width || 700));
      var fs = clamp(11.5 * px, 14, 34), fsS = clamp(10 * px, 12, 28), ink = '#3A2E2B', soft = '#8A807B', red = '#B71935', line = '#C9C0B6';
      var L = c.L, H = c.H || (c.mode === 'linear' ? null : (c.s ? c.s * .75 : 8)), counter = c.counter;
      var hang = P.hangFor(c.ceil), topOfFix = counter + hang + (H || 8);
      var span = c.ceil ? Math.max(c.ceil, topOfFix + 6) : topOfFix + 14;
      var left = 90 + fs * 2.2, right = W - 70 - fs * 2.6, avail = right - left;
      // On screen the view switcher sits above the drawing; the PDF keeps room for its title
      var topY = opts.pdf ? 100 : Math.max(46, 30 * px);
      var floorY = Ht - 70 - fs * 2.6, usableH = floorY - topY - 10;
      var sc = Math.min(avail / L, usableH / span);
      var cx = (left + right) / 2, xl = cx - L * sc / 2, xr = cx + L * sc / 2, Y = function (inch) { return floorY - inch * sc; };
      el('rect', { x: 0, y: 0, width: W, height: Ht, fill: '#FBF9F6' }, S);
      if (opts.pdf) el('text', { x: 40, y: 34 + fsS, 'font-size': fsS, fill: soft, 'letter-spacing': '.18em', 'font-weight': 600 }, S, 'FRONT ELEVATION · NOT TO A FIXED SCALE');
      // floor, island, counter
      el('line', { x1: 30, y1: floorY, x2: W - 30, y2: floorY, stroke: line, 'stroke-width': 1.2 }, S);
      var slab = Math.max(3, 1.5 * sc);
      el('rect', { x: xl, y: Y(counter), width: xr - xl, height: counter * sc, fill: '#EFE9E2', stroke: line }, S);
      el('rect', { x: xl - 2, y: Y(counter), width: xr - xl + 4, height: slab, fill: '#D9CFC4' }, S);
      // ceiling
      var ceilY = c.ceil ? Y(c.ceil) : topY;
      el('line', { x1: 30, y1: ceilY, x2: W - 30, y2: ceilY, stroke: c.ceil ? ink : line, 'stroke-width': c.ceil ? 1.4 : 1, 'stroke-dasharray': c.ceil ? null : '6 6' }, S);
      el('text', { x: 40, y: ceilY + fsS + 6, 'font-size': fsS, fill: soft }, S, c.ceil ? 'Ceiling' : 'Ceiling · height not set');
      // fixtures
      var shadeBot = Y(counter + hang), pos = [];
      if (c.mode === 'multi' && c.chosen) pos = c.chosen.pos.map(function (p) { return { x: xl + p * sc, w: c.s * sc }; });
      else if (c.mode === 'linear' && c.chosen) pos = [{ x: cx, w: c.len * sc }];
      // The product's own outline when its cutout is known (width and height to the published sizes), else a plain shape
      var sil = c.sil && c.sil.d ? c.sil : null, silH = sil ? sil.h - sil.st : 0;
      var hFix = H ? H * sc : (sil && pos.length ? pos[0].w * silH / sil.w : 8 * sc);
      var defs = el('defs', {}, S), tid = 'hlt' + Math.random().toString(36).slice(2, 7);
      if (sil) { var cp = el('clipPath', { id: tid }, defs); el('rect', { x: -50, y: sil.st, width: sil.w + 100, height: silH + 50 }, cp); }
      pos.forEach(function (p, i) {
        var t = shadeBot - hFix, known = !!(c.H || c.mode === 'linear');
        el('line', { x1: p.x, y1: ceilY, x2: p.x, y2: t, stroke: ink, 'stroke-width': 1.2, 'stroke-dasharray': c.ceil ? null : '2 3' }, S);
        el('rect', { x: p.x - 12, y: ceilY, width: 24, height: 4, fill: ink }, S);
        // Numbered mounting point
        var r = fsS * .62, my = ceilY - r - 6 > 8 ? ceilY - r - 6 : ceilY + r + 10;
        el('circle', { cx: p.x, cy: my, r: r, fill: red }, S);
        el('text', { x: p.x, y: my + fsS * .3, 'text-anchor': 'middle', 'font-size': fsS * .78, 'font-weight': 600, fill: '#fff' }, S, String(i + 1));
        if (sil) {
          var kx = p.w / sil.w, ky = hFix / silH;
          var g = el('g', { transform: 'translate(' + (p.x - p.w / 2) + ' ' + t + ') scale(' + kx + ' ' + ky + ') translate(0 ' + (-sil.st) + ')' }, S);
          el('path', { d: sil.d, 'clip-path': 'url(#' + tid + ')', 'fill-rule': 'evenodd', fill: '#FFFFFF', stroke: known ? ink : soft, 'stroke-width': 1.3, 'vector-effect': 'non-scaling-stroke', 'stroke-dasharray': known ? null : '5 4' }, g);
        } else el('rect', { x: p.x - p.w / 2, y: t, width: p.w, height: hFix, rx: Math.min(p.w, hFix) * .35, fill: '#FFFFFF', stroke: known ? ink : soft, 'stroke-width': 1.4, 'stroke-dasharray': known ? null : '5 4' }, S);
        el('line', { x1: p.x, y1: shadeBot + 8, x2: p.x, y2: floorY + 22, stroke: red, 'stroke-width': .9, 'stroke-dasharray': '7 3 2 3' }, S);
        if (i === 0 && !c.H && c.mode !== 'linear') el('text', { x: p.x, y: t + hFix / 2 + fsS * .35, 'text-anchor': 'middle', 'font-size': fsS * .8, fill: soft }, S, 'height n/a');
        if (i === 0) {
          var dy = t - fs * .5;
          el('text', { x: p.x, y: dy, 'text-anchor': 'middle', 'font-size': fsS, fill: ink }, S, (c.mode === 'linear' ? 'L ' : 'Ø ') + P.frac(c.mode === 'linear' ? c.len : c.s));
        }
      });
      // horizontal chain under the island
      var y1 = floorY + 20 + fs * .2, y2 = y1 + fs * 1.7;
      function hdim(a, b, y, text, sub) {
        el('line', { x1: a, y1: y, x2: b, y2: y, stroke: ink, 'stroke-width': 1 }, S);
        [a, b].forEach(function (x) { el('line', { x1: x - 4, y1: y + 4, x2: x + 4, y2: y - 4, stroke: ink, 'stroke-width': 1.4 }, S); });
        if (b - a > fs * 2.2) el('text', { x: (a + b) / 2, y: y - 5, 'text-anchor': 'middle', 'font-size': fsS, fill: ink }, S, text + (sub && b - a > fs * 6 ? '  ' + sub : ''));
      }
      if (pos.length && c.mode === 'multi') {
        var xs = [xl].concat(pos.map(function (p) { return p.x; })).concat([xr]);
        for (var i = 0; i < xs.length - 1; i++) {
          var seg = (xs[i + 1] - xs[i]) / sc;
          hdim(xs[i], xs[i + 1], y1, P.frac(seg), P.cm(seg));
        }
      } else if (pos.length) {
        hdim(xl, pos[0].x - pos[0].w / 2, y1, P.frac(c.chosen.clear)); hdim(pos[0].x - pos[0].w / 2, pos[0].x + pos[0].w / 2, y1, P.frac(c.len)); hdim(pos[0].x + pos[0].w / 2, xr, y1, P.frac(c.chosen.clear));
      }
      [xl, xr].forEach(function (x) { el('line', { x1: x, y1: Y(counter), x2: x, y2: y2 + 6, stroke: line, 'stroke-width': .8 }, S); });
      hdim(xl, xr, y2, 'Island ' + P.frac(L), P.cm(L));
      // Mounting points measured from the left end of the island (indicative: confirm on site)
      if (pos.length && !opts.pdf) {
        var mp = 'Mounting points from the left end: ' + pos.map(function (p) { return P.frac((p.x - xl) / sc); }).join(' · ') + ' (indicative)';
        el('text', { x: cx, y: y2 + fsS * 1.9, 'text-anchor': 'middle', 'font-size': Math.min(fsS * .92, 1750 / mp.length), fill: soft }, S, mp);
      }
      // vertical dimensions
      function vdim(x, a, b, text, anchor) {
        el('line', { x1: x, y1: a, x2: x, y2: b, stroke: ink, 'stroke-width': 1 }, S);
        [a, b].forEach(function (y) { el('line', { x1: x - 4, y1: y + 4, x2: x + 4, y2: y - 4, stroke: ink, 'stroke-width': 1.4 }, S); });
        var tx = anchor === 'end' ? x - 8 : x + 8;
        String(text).split('\n').forEach(function (t, k) { el('text', { x: tx, y: (a + b) / 2 + fsS * .35 + k * fsS * 1.2 - (String(text).split('\n').length - 1) * fsS * .6, 'text-anchor': anchor || 'start', 'font-size': fsS, fill: k ? soft : ink }, S, t); });
      }
      var vx = xr + 18;
      vdim(vx, Y(0), Y(counter), 'Counter\n' + P.frac(counter));
      if (pos.length) {
        vdim(vx, Y(counter), shadeBot, '30–36″\nabove counter');
        if (c.H || c.mode === 'linear') vdim(xl - 18, shadeBot - hFix, shadeBot, 'Fixture\n' + P.frac(c.H || 0), 'end');
        if (c.ceil && c.drop) vdim(vx, ceilY, shadeBot - hFix, 'Suspension ≈ ' + P.frac(Math.max(0, c.drop.mid)) + '\n' + (c.cord != null ? 'listed cord ' + P.frac(c.cord) : 'cord not published'));
      }
      if (c.ceil) vdim(W - 34, Y(0), ceilY, 'Ceiling\n' + P.frac(c.ceil), 'end');
      if (!pos.length) el('text', { x: cx, y: (ceilY + Y(counter)) / 2, 'text-anchor': 'middle', 'font-size': fs, fill: red }, S, c.mode === 'linear-unknown' ? 'Fixture length not published' : 'This shade does not fit this island');
      return S;
    }

    /* ---------- render ---------- */
    function render() {
      cur = compute();
      showLength(); showShade(cur); showConfigs(cur); showMessage(cur); showStats(cur); showPrice(cur);
      if (state.view === 'scene') drawScene(cur); else drawTech(tsvg, cur);
      var link = q('[data-shop-link]');
      if (link && cur.chosen) link.href = link.getAttribute('href').split('?')[0] + '?ip_len=' + Math.round(cur.L * 4) / 4 + (state.ceil ? '&ip_ceil=' + state.ceil : '') + '#island-planner';
    }
    function setLength(v, fromUnit) {
      var x = parseFloat(v); if (!isFinite(x)) return;
      if ((fromUnit || state.unit) === 'cm') x = x / 2.54;
      state.L = clamp(x, 36, 240); state.n = null; keep(); render();
    }
    // Remember the island for the collection page and the other product pages
    var kt; function keep() { clearTimeout(kt); kt = setTimeout(function () { P.save({ L: state.L, ceil: state.ceil, unit: state.unit }); follow(); }, 250); }
    // Once the shopper has given an island length, the buy box and "Choose your set" follow the planner's quantity
    function follow() { if (isProduct && cur && cur.mode === 'multi' && cur.chosen && cur.n) setQtyInForm(cur.n); }

    /* ---------- events ---------- */
    num.addEventListener('input', function () { var x = parseFloat(num.value); if (isFinite(x)) { var inch = state.unit === 'cm' ? x / 2.54 : x; if (inch >= 36 && inch <= 240) { state.L = inch; state.n = null; keep(); render(); } } });
    num.addEventListener('change', function () { setLength(num.value); num.blur(); });
    range.addEventListener('input', function () { state.L = Number(range.value); state.n = null; keep(); render(); });
    qa('[data-preset]').forEach(function (b) { b.addEventListener('click', function () { setLength(b.dataset.preset, 'in'); }); });
    qa('[data-unit]').forEach(function (b) { b.addEventListener('click', function () { state.unit = b.dataset.unit; keep(); render(); }); });
    ceilNum.addEventListener('change', function () { var x = parseFloat(ceilNum.value); state.ceil = isFinite(x) && x > 0 ? clamp(state.unit === 'cm' ? x / 2.54 : x, 72, 240) : null; keep(); render(); });
    qa('[data-ceil]').forEach(function (b) { b.addEventListener('click', function () { var v = Number(b.dataset.ceil); state.ceil = state.ceil === v ? null : v; keep(); render(); }); });
    counterNum.addEventListener('change', function () { var x = parseFloat(counterNum.value); if (isFinite(x)) state.counter = clamp(state.unit === 'cm' ? x / 2.54 : x, 24, 48); render(); });
    qa('[data-step]').forEach(function (b) { b.addEventListener('click', function () { state.userShade = clamp(state.userShade + Number(b.dataset.step), 4, 48); state.n = null; render(); }); });
    q('[data-configs]').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-n]'); if (!b || b.disabled) return;
      state.n = Number(b.dataset.n); render();
      if (isProduct && cur.chosen) setQtyInForm(cur.n);
    });
    q('[data-configs]').addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var bs = [].slice.call(qa('[data-configs] button:not(:disabled)')), i = bs.indexOf(document.activeElement);
      var nb = bs[(i + (e.key === 'ArrowRight' ? 1 : -1) + bs.length) % bs.length]; if (nb) { nb.focus(); nb.click(); e.preventDefault(); }
    });
    qa('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.view = b.dataset.view;
        qa('[data-view]').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        q('[data-scene]').hidden = state.view !== 'scene'; q('[data-tech]').hidden = state.view !== 'tech';
        q('[data-cap]').hidden = true;
        render();
      });
    });
    var add = q('[data-add]'); if (add) add.addEventListener('click', function () { cartMutate('add'); });
    var setBtn = q('[data-set]'); if (setBtn) setBtn.addEventListener('click', function () { cartMutate('set'); });
    // "Choose your set" picked by the shopper: follow it when that layout fits
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.hl-bundle [data-qty]'); if (!b || !e.isTrusted || !cur || cur.mode !== 'multi') return;
      var n = Number(b.dataset.qty); if (cur.all[n - 1] && cur.all[n - 1].ok) { state.n = n; render(); }
    });
    document.addEventListener('variant:update', function () { setTimeout(render, 80); });
    document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'id' || (e.target.closest && e.target.closest('variant-picker')))) setTimeout(render, 120); });
    document.addEventListener('shopify:cart:lines-update', function (e) { var p = e.promise || (e.detail && e.detail.promise); if (p && p.then) p.then(refreshCart, refreshCart); else setTimeout(refreshCart, 800); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 120); });
    var pdfBtn = q('[data-pdf]');
    if (pdfBtn) pdfBtn.addEventListener('click', function () {
      if (pdfBtn.disabled) return;
      var lab = q('[data-pdf-label]'), txt = lab.textContent;
      pdfBtn.disabled = true; lab.textContent = 'Preparing your plan…';
      loadScript(D.shop.pdf).then(function () {
        var c = compute(), techClone = document.createElementNS(NS, 'svg');
        techClone.setAttribute('viewBox', '0 0 1000 680');
        drawTech(techClone, c, { px: 1.6, pdf: true });
        // The PDF keeps its own measurement drawing on the illustration; the screen is redrawn right after
        var keepView = state.view, sb = q('[data-scene]');
        state.view = 'scene'; sb.hidden = false; drawScene(c, { pdf: true });
        var sceneClone = svg.cloneNode(true);
        state.view = keepView;
        if (keepView === 'scene') drawScene(c); else { sb.hidden = true; q('[data-cap]').hidden = true; }
        return window.HLPlannerPDF({ c: c, D: D, P: P, R: R, unit: state.unit, scene: sceneClone, sceneZoom: Math.min(1, SC.REF / c.L), photo: photo.currentSrc || photo.src, tech: techClone, price: isProduct ? priceFor(c, 'alone') : null });
      }).then(function () { lab.textContent = txt; pdfBtn.disabled = false; })
        .catch(function (e) { if (window.console) console.warn('[planner pdf]', e); lab.textContent = 'Please try again'; setTimeout(function () { lab.textContent = txt; pdfBtn.disabled = false; }, 2500); });
    });

    if (isProduct) refreshCart();
    if (isProduct && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { document.documentElement.classList.toggle('hl-pl-onscreen', en[0].isIntersecting); }, { rootMargin: '-12% 0px -12% 0px' }).observe(root);
    render();
    if (params.get('ip_len') || kept.L) setTimeout(follow, 300);
  }

  var loading = {};
  function loadScript(src) {
    if (!loading[src]) loading[src] = new Promise(function (ok, ko) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = function () { loading[src] = null; ko(new Error('load ' + src)); }; document.head.appendChild(s); });
    return loading[src];
  }
  window.HLPlannerLoad = loadScript;

  function boot() { document.querySelectorAll('[data-hl-planner]').forEach(function (r) { if (!r.__hlp) { r.__hlp = 1; Planner(r); } }); }
  if (window.HLPlan) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot(); }
  else document.addEventListener('hlplan:ready', boot);
})();
